import React from 'react';
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from '@mui/icons-material';
import { makeStyles, IconButton } from '@material-ui/core';
import { TablePaginationActionsProps as TablePaginationActionsPropsV5 } from '@mui/material/TablePagination/TablePaginationActions';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

type PageMouseEvent = React.MouseEvent<HTMLButtonElement> | null;

type Props = {
  count: number;
  page: number;
  rowsPerPage: number;
  onChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
};
const TablePaginationActions: React.ElementType<Props> = ({
  count,
  page,
  rowsPerPage,
  onChangePage,
}) => {
  const classes = useStyles1();

  const totalPages = Math.ceil(count / rowsPerPage);

  const handleFirstPageButtonClick = (event: PageMouseEvent): void => onChangePage(event, 0);
  const handleBackButtonClick = (event: PageMouseEvent): void => onChangePage(event, page - 1);
  const handleNextButtonClick = (event: PageMouseEvent): void => onChangePage(event, page + 1);
  const handleLastPageButtonClick = (event: PageMouseEvent): void =>
    onChangePage(event, Math.max(0, totalPages - 1));

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPage />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= totalPages - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= totalPages - 1 || count > 50000}
        aria-label="last page"
      >
        <LastPage />
      </IconButton>
    </div>
  );
};

export const TablePaginationActionsV5 = (props: TablePaginationActionsPropsV5) => (
  <TablePaginationActions {...props} onChangePage={props.onPageChange} />
);

export default TablePaginationActions;
